import { Alert, Box, Typography } from '@mui/material';
import { useAppConfigStore, type TourUrls } from '../../config/appConfigStore';

/** One of the four "Turlar" iframe screens (legacy `Tours/International|Cruise|Cultural|Cyprus`).
 *  The embed URLs come from `REACT_APP_TOUR_URL_*` env vars (see config/appConfigStore.ts);
 *  if unset the page shows a notice instead of a broken frame. */
export function TourIframePage({ kind, title }: { kind: keyof TourUrls; title: string }) {
  const tourUrls = useAppConfigStore((s) => s.tourUrls);
  const url = tourUrls?.[kind];

  return (
    <Box sx={{ height: 'calc(100vh - 128px)', display: 'flex', flexDirection: 'column' }}>
      <Typography variant="h5" gutterBottom>
        {title}
      </Typography>
      {url ? (
        <Box
          component="iframe"
          src={url}
          title={title}
          sx={{ flexGrow: 1, width: '100%', border: 0, borderRadius: 1 }}
        />
      ) : (
        <Alert severity="info">Tur entegrasyonu adresi yapılandırılmamış.</Alert>
      )}
    </Box>
  );
}
